import styled from '../../../lib/styled';
import React from 'react';
import { FC } from 'react';
import { colors } from '../../Shared/Style/colors';
import Icon from '../event-ticket.svg';

const ThemedTicket = styled(Icon)(() => {
    return {
        height: '24px',
        width: '24px',
        '& g': {
            stroke: colors.icons,
        },
        '& path': {
            stroke: colors.icons,
        },
        '& polyline': {
            stroke: colors.icons,
        },
    };
});
const Ticket: FC = ({ ...rest }) => {
    return <ThemedTicket {...rest} />;
};

export default Ticket;
